import React from 'react';
import HeaderDesktop from './HeaderDesktop';
import HeaderMobile from './HeaderMobile';
import { Container } from 'react-bootstrap';
import useWindowDimensions from './../../hooks/useWindowDimensions';

export default function Header() {
  const { width } = useWindowDimensions();

  return (
    <header>
      <Container fluid className="h-100">
        {width < 768 ? <HeaderMobile /> : <HeaderDesktop />}
      </Container>
    </header>
  );
}
